import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { v4 } from "uuid";
import { ChecklistSection } from "./ChecklistSection";
import { ChecklistLibrarySection } from "./ChecklistLibrarySection";

export const ChecklistDrawerContent = forwardRef(
  (
    {
      checklist,
      currentContent = "list",
      onImportClick,
      source,
      onChange,
      isNew,
      checklistInputError,
      setChecklistInputError,
    }: {
      checklist: any;
      currentContent: "list" | "library";
      onImportClick: () => void;
      source: "controlCenter" | "other";
      onChange?: (data: any) => void;
      isNew?: boolean;
      checklistInputError?: any;
      setChecklistInputError?: (data: any) => void;
    },
    ref,
  ) => {
    const checklistRef = useRef<any>(null);
    const libraryRef = useRef<any>(null);

    const [checklistData, setChecklistData] = useState<any>(
      defaultDataBuilder(checklist),
    );
    const [selectedLibraryData, setSelectedLibraryData] = useState<any>([]);

    useEffect(() => {
      if (checklistData?.items.length > 0 && setChecklistInputError) {
        setChecklistInputError(false);
      }
    }, [checklistData, setChecklistInputError]);

    useEffect(() => {
      setChecklistData(defaultDataBuilder(checklist));
    }, [checklist]);

    useImperativeHandle(ref, () => {
      return {
        submit: () =>
          currentContent === "list"
            ? checklistRef.current?.submit()
            : onImportFromLibraryData(),
      };
    });
    const onImportFromLibraryData = () => {
      const selectedChecklist = libraryRef.current?.submit();
      setSelectedLibraryData(selectedChecklist);
      setChecklistData((oldaData: any) => ({
        ...oldaData,
        items: manageLibraryFiles(oldaData, selectedChecklist),
      }));
      return selectedChecklist;
    };
    return (
      <>
        {currentContent === "list" ? (
          <ChecklistSection
            ref={checklistRef}
            checklistData={checklistData}
            onChange={(data: any) => {
              setChecklistData(data);
              if (onChange) {
                onChange(data);
              }
            }}
            onImportClick={onImportClick}
            source={source}
            isNew={isNew}
            checklistInputError={checklistInputError}
            setChecklistInputError={setChecklistInputError}
          />
        ) : (
          <ChecklistLibrarySection
            ref={libraryRef}
            selectedChecklist={selectedLibraryData}
          />
        )}
      </>
    );
  },
);

const defaultDataBuilder = (data: any) => {
  return {
    ...data,
    checklist_title: data?.checklist_title || "",
    items:
      (data?.items || []).length > 0
        ? data?.items?.map((item: any) => ({
            key: v4(),
            data: {
              ...item,
              checklist_item_name: item.checklist_item_name || "",
              order: item.order || 1,
              is_important: item.is_important === true,
            },
          }))
        : [],
  };
};

const manageLibraryFiles = (data: any, libraryData: any) => {
  let newDataList = [];
  newDataList = data.items.filter(
    (item: any) =>
      item?.data?.item_id === undefined || validate(item, libraryData),
  );
  newDataList = [...fetchUnaddedItems(newDataList, libraryData)];
  return newDataList;
};

const fetchUnaddedItems = (
  newDataList: Array<any>,
  libraryDatalist: Array<any>,
) => {
  let unAddedList = newDataList;

  for (const libraryData of libraryDatalist) {
    const result = libraryData.items
      .filter((item: any) =>
        unAddedList.every(
          (newData) => item?.item_id !== newData?.data?.item_id,
        ),
      )
      .map((item: any) => ({
        key: item.item_id,
        data: item,
      }));
    unAddedList = [...unAddedList, ...result];
  }
  return unAddedList;
};

const validate = (data: any, libraryDatalist: Array<any>) => {
  for (const libraryData of libraryDatalist) {
    if (
      libraryData.items.find(
        (item: any) => item.item_id === data?.data?.item_id,
      ) !== undefined
    ) {
      return true;
    }
  }
  return false;
};
